module.exports = __webpack_public_path__ + "media/crowd.88625bde.mp4";